import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { DesignCrossesComponent } from './design-crosses.component';
import { DESIGN_CROSSES_ROUTES_ROOT } from './design-crosses.route';
import { DesignCrossesContext } from './design-crosses.context';
import { SourceListComponent } from './source-list.component';
import { ParentsListComponent } from './parents-list.component';
import { PreviewCrossesComponent } from './preview-crosses.component';
import { CrossingSettingsModalComponent } from './crossing-settings-modal.component';
import { ExistingCrossesModalComponent } from './existing-crosses.modal.component';
import { ExpandableCellComponent } from '../shared/component/expandable-cell.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SelectionCountComponent } from '../shared/selection-count/selection-count.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    declarations: [
        DesignCrossesComponent,
        SourceListComponent,
        ParentsListComponent,
        PreviewCrossesComponent,
        CrossingSettingsModalComponent,
        ExistingCrossesModalComponent
    ],
    providers: [
        DesignCrossesContext
    ],
    imports: [
        DragDropModule,
        BmsjHipsterSharedModule,
        RouterModule.forChild(DESIGN_CROSSES_ROUTES_ROOT),
        ExpandableCellComponent,
        ScrollingModule,
        SelectionCountComponent,
        TruncateSpanComponent,
        HelpLinkComponent
    ]
})
export class DesignCrossesModule {
}
